<script lang="ts">
import { defineComponent, onUpdated } from 'vue';
import { string } from 'vue-types';

import { getConfig } from '~/config/constants';

const config = getConfig(useRuntimeConfig());

const updateTitle = (title: string) => {
  const envPrefix = config.env && config.env !== 'production'
    ? `[${config.env?.charAt(0).toUpperCase()}] - `
    : '';
  if (title) {
    document.title = `${envPrefix} ${title} | ${config.title}`;
  } else {
    document.title = `${envPrefix} ${config.title}`;
  }
};

export default defineComponent({
  name: 'HeadTitle',
  props: {
    title: string().def(''),
  },
  setup(properties) {
    updateTitle(properties.title);
    onUpdated(() => { updateTitle(properties.title); });
  },
});
</script>

<template>
  <span />
</template>
